import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScrollArea from '../BuildingBlocks/ScrollArea/ScrollArea.js';
import FormElements from '../FormElements/FormElements.js';
import Grid from '../Utility/Grid/Grid.js';
import { AgreementAuthErrorMessage, AgreementAuthWrapper } from './AgreementAuthentication.styles.js';
import Text from '../BuildingBlocks/Text/Text.js';

class AgreementAuthentication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableCheckbox: true
    };
  }

  static propTypes = {
    /**
     * Sets the value of the checkbox.
     */
    checked: PropTypes.bool,
    /**
     * The content of the agreement
     */
    children: PropTypes.node,
    /**
     * Disables the checkbox
     */
    disabled: PropTypes.bool,
    /**
     * Sets an error message
     */
    error: PropTypes.string,
    /**
     * Title of the agreement that is used as a title
     */
    header: PropTypes.string.isRequired,
    /**
     * Label for the checkbox of the agreement
     */
    labelText: PropTypes.string.isRequired,
    /**
     * Name for the checkbox input
     */
    name: PropTypes.string,
    /**
     * Callback fired when the value is checked/unchecked
     */
    onChange: PropTypes.func,
    /**
     * Prompt label that sits below the header
     */
    scrollPromptText: PropTypes.string
  };

  static defaultProps = {
    checked: false,
    children: null,
    disabled: false,
    error: undefined,
    name: undefined,
    onChange: undefined,
    scrollPromptText: 'Please scroll to read the terms'
  };

  handleScroll = event => {
    // Magic number "5" fixes some Android issues we're now checking if the user scrolled "nearly" to the bottom
    const maxScroll = event.target.scrollHeight - event.target.clientHeight - 5;

    if (event.target.scrollTop >= maxScroll) {
      this.setState({ disableCheckbox: false });
    }
  };

  render() {
    const { checked, children, disabled, error, header, labelText, name, onChange, scrollPromptText } = this.props;
    const { disableCheckbox } = this.state;
    return (
      <div>
        <AgreementAuthWrapper error={error !== undefined}>
          <Text.HeadingFourth tagName="h3">{header}</Text.HeadingFourth>
          <Text.HeadingFifth color="quaternary" tagName="p" noMargins>
            {scrollPromptText}
          </Text.HeadingFifth>

          <Grid.ScreenClassRender
            render={screenClass => (
              <ScrollArea
                maxHeight={['xs', 'sm'].includes(screenClass) ? 335 : 230}
                shadowColor="grey"
                onScroll={this.handleScroll}
              >
                {children}
              </ScrollArea>
            )}
          />

          <FormElements.Checkbox
            name={name}
            checked={checked}
            disabled={disabled || disableCheckbox}
            label={labelText}
            onChange={onChange}
          />
        </AgreementAuthWrapper>
        {error && <AgreementAuthErrorMessage>{error}</AgreementAuthErrorMessage>}
      </div>
    );
  }
}

export default AgreementAuthentication;
